// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"ecac104f","132":"9240a99e","484":"bb370e51","681":"944be083"}[chunkId] + ".chunk.js";
};